module.exports = __webpack_public_path__ + "img/event-note.ef94c623.svg";